import { Button, Grid, Box, Chip, Tooltip } from "@mui/material";
import DataTable from "../../../components/features/Datatable";
import Filter from "./Filter";
import BsModal from "../../../components/common/BaseModal";
import AssignApheresisDateForm from "./AssignApheresisDateForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApheresisRequestList, apheresisRequestList } from "../../../slices/feasibility";
import { hasAuthority } from "../../../../utils/authorities";
import { AccessDenied } from "../../../../pages/access-denied/AccessDenied";
import ChatModule from "../../Chat/index"
import moment from "moment";
import { addPatientList, addPhaseList } from "../../../slices/chat";

const filterConfig = {
    type: {
        label: "Type",
        enum: {
            1: 'Trial',
            2: 'PMS',
            3: 'Commercial',
        },
    },
    apheresis_date: {
        label: "Apheresis Date",
    },
}
const ApheresisRequests = () => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const [rowData, setRowData] = useState(null)
    const allApheresisList = useSelector(apheresisRequestList)
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || []
    const updateFilter = (filter) => {
        fetchUsers(filter)
    }

    useEffect(() => {
        const phaseList = allApheresisList?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase} (${op?.product})`, patient_id: op?.subject_id } })
        const patientList = allApheresisList?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
        dispatch(addPatientList(patientList))
        dispatch(addPhaseList(phaseList))
    }, [allApheresisList])

    const handleCloseModal = () => {
        setOpen(false);
    };

    const fetchUsers = async (filter) => {
        await dispatch(getApheresisRequestList(filter))
    }
    const columns = [
        { id: "patient_id", name: "Subject/Patient ID", selector: row => row.patient_id ? row.patient_id : "N/A", sortable: true },
        { id: "subject_name", name: "Subject Name", selector: row => row.subject_name ? row.subject_name : "N/A", sortable: true },
        { id: "product", name: "Product/Phase", selector: row => row.product && row.phase ? `${row.product}/${row.phase}` : "N/A", sortable: true },
        { id: "phase_type", name: "Type", selector: row => row.phase_type ? row.phase_type : "N/A", sortable: true },
        { id: "hospital_name", name: "Hospital", selector: row => row.hospital_name ? row.hospital_name : "N/A", sortable: true },
        {
            id: "request_date", name: "Request Date", selector: row => {
                if (row?.request_date) {
                    let [startDateStr, endDateStr] = row.request_date.split(' - ');
                    let formattedStart = moment(startDateStr).format("DD/MM/YYYY");
                    let formattedEnd = moment(endDateStr).format("DD/MM/YYYY");
                    return `${formattedStart} - ${formattedEnd}`
                } else {
                    return "N/A"
                }

            }, sortable: true
        },
        {
            name: "Action",
            align: "center",
            selector: row => (
                hasAuthority(["assign-apheresis-date"], bmr_permissions)
                    && row?.apheresis_requested_date
                    ? <Chip color="success" label={row?.apheresis_requested_date ? moment(row?.apheresis_requested_date).format("DD/MM/YYYY") : ""} />
                    : (row.version == 1
                        ? <Tooltip
                            placement="top"
                            arrow
                            title={(row?.is_open_request && row.version == 1) ? "There is an open query" : "Assign Apheresis Date"}
                        >
                            <Button
                                onClick={() => { setOpen(true), setRowData(row) }}
                                disabled={row?.apheresis_requested_date || row?.is_open_request}
                                key={row.id}
                                size="small"
                                className="!w-[150px]"
                            >
                                Assign Apheresis Date
                            </Button>
                        </Tooltip> : <Tooltip
                            placement="top"
                            arrow
                            title={"Approve Apheresis Date"}
                        >
                            <Button
                                onClick={() => { setOpen(true), setRowData(row) }}
                                key={row.id}
                                size="small"
                                className="!w-[150px]"
                            >
                                Booked Date
                            </Button>
                        </Tooltip>)

            ),
        },
    ];


    return (
        <div>
            {hasAuthority(["apheresis-requests-listing"], bmr_permissions)
                ? <Box>
                    <Grid container className="mt-4 ml-0 mainDiv" rowSpacing={4.5} columnSpacing={2.75}>
                        <Grid item xs={12} sx={{ mt: -2.25 }}>
                            <DataTable
                                filterConfig={filterConfig}
                                columns={columns}
                                data={allApheresisList ?? []}
                                title="Apheresis Request"
                                FilterComponent={Filter}
                                onServerSideChange={updateFilter}
                                remote={true}
                            />
                        </Grid>
                    </Grid>
                    <BsModal open={open} onClose={handleCloseModal} title="SLOT BOOKING/CONFIRMATION">
                        <AssignApheresisDateForm
                            fetchUsers={fetchUsers}
                            rowData={rowData}
                            handleCloseModal={handleCloseModal} />
                    </BsModal>
                </Box> : <AccessDenied />
            }
            <ChatModule />
        </div>
    );
};

export default ApheresisRequests;
